(function( global, $, Handlebars, EventData ) { // eslint-disable-line
    var pluginName = 'Events';

    // Constructor
    function Events() {
        this.event = {};
        this.element = null;
        this.view = {};
        this.data = {};
    }

    /**
     * Build event card or event list
     *
     * @param {object} event
     * @param {object} element
     * @param {object} view
     */
    Events.prototype.render = function render(event, element, view) {
        this.event = event;
        this.element = element;
        this.view = view;
        this.data = EventData(event);

        if (this.view.type === 'listWeek' || this.view.type === 'listMonth') {
            var sourceList = $('[pc-event-list-template]').html();
            var templateList = Handlebars.compile(sourceList);
            this.element.find('.fc-list-item-title').html(templateList(this.data));
        } else {
            var sourceTile = $('[pc-event-template]').html();
            var templateTile = Handlebars.compile(sourceTile);
            this.element.html(templateTile(this.data));
        }
    };

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports)
        module.exports = Events; // Export to Browser
    else
        global[pluginName] = Events; // eslint-disable-line

}( window.groots, jQuery, require('handlebars'), require('./_eventdata.js') ));
